import { Module } from '@nestjs/common'
import { CustomerSettingsController, SettingsController } from './controllers'
import { SettingsService } from './services'

@Module({
	controllers: [SettingsController, CustomerSettingsController],
	providers: [SettingsService],
})
export class SettingsModule {}
